export default __webpack_public_path__ + "static/media/unsplash_martenBjork_airplaneCode.e5d0a078.jpg";